import type { CaptionCreationPanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { AttributePanel } from "../AttributePanel";
import { CaptionFormField } from "./CaptionFormField";
import { useCreateCaptionFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: CaptionCreationPanelFragment;
  onDelete: () => Promise<void>;
};

export function CaptionCreationPanel({ fragment, onDelete }: Props) {
  const { t } = useTranslation();
  const [createAttribute] = useCreateCaptionFromPanelMutation();
  const [linkedRegionId, setLinkedRegionId] = useState<string>();

  const onSave = async () => {
    await createAttribute({
      variables: {
        regionId: fragment.id,
        linkedRegionId,
      },
    });
    await onDelete();
  };

  return (
    <AttributePanel
      title={t("CaptionCreationPanel.title")}
      unsaved
      onSubmit={onSave}
      onDelete={onDelete}
    >
      <CaptionFormField
        fragment={fragment}
        value={linkedRegionId ?? ""}
        onValueChange={setLinkedRegionId}
      />
    </AttributePanel>
  );
}
